import { Injectable } from '@angular/core';
import { State, getLanguage, getSupportedLanguages } from '@app/app.reducer';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MissingTranslationService {
  constructor(private store: Store<State>) {}

  getLanguage() {
    let activeLanguage: string;

    this.store
      .select(getLanguage)
      .pipe(filter((data) => !!data))
      .subscribe((language) => {
        activeLanguage = language;
      });

    return activeLanguage;
  }

  getSupportedLanguages() {
    let supportedLanguages: string[];

    this.store
      .select(getSupportedLanguages)
      .pipe(filter((languages) => languages && languages.length > 0))
      .subscribe((languages) => {
        supportedLanguages = languages;
      });

    return supportedLanguages;
  }
}
